import { Divider, Link, styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import PermissionGuard from 'components/PermissionGuard';
import {
  TextV2,
  SvgAlertDiamondBold,
} from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

const StyledExclamationIcon = styled(SvgAlertDiamondBold)(({ theme }) => ({
  marginRight: theme.spacing(spacingSizeMap.XS),
}));

const QuickActions = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Grid
        container
        sx={[
          {
            alignItems: 'center',
          },
          (theme) => ({
            svg: {
              fill: theme.palette.grey[700],
            },
          }),
        ]}
      >
        <StyledExclamationIcon height={20} width={20} />
        <TextV2 component="h2" variant="h4" color="textPrimary">
          {t('ui.event-management.dashboard.quick-actions.heading')}
        </TextV2>
      </Grid>
      <Divider
        sx={(theme) => ({
          margin: `${theme.spacing(spacingSizeMap.XS)} 0`,
        })}
      />
      <PermissionGuard
        requiredPermissions={[
          { action: 'Organisation_Create', scope: 'Global' },
        ]}
      >
        <Link component={RouterLink} to={{ pathname: '/organisations/add' }}>
          <TextV2 color="primary">
            {t('ui.event-management.dashboard.quick-actions.new-organisation')}
          </TextV2>
        </Link>
      </PermissionGuard>
      <PermissionGuard
        requiredPermissions={[
          {
            action: 'Experience_Create',
            scope: 'Local',
          },
        ]}
      >
        <Link component={RouterLink} to="/experiences/create">
          <TextV2 color="primary">
            {t('ui.event-management.dashboard.quick-actions.new-event')}
          </TextV2>
        </Link>
      </PermissionGuard>
      <PermissionGuard
        requiredPermissions={[
          {
            action: 'Organisation_InvitePractitioner',
            scope: 'Global',
          },
        ]}
      >
        <Link component={RouterLink} to="/organisations/invite-user">
          <TextV2 color="primary">
            {t('ui.event-management.dashboard.quick-actions.new-user')}
          </TextV2>
        </Link>
      </PermissionGuard>
      <PermissionGuard
        requiredPermissions={[
          {
            action: 'Team_Create',
            scope: 'Local',
          },
        ]}
      >
        <Link component={RouterLink} to="/teams/create">
          <TextV2 color="primary">
            {t('ui.event-management.teams.create-new-team')}
          </TextV2>
        </Link>
      </PermissionGuard>
      <PermissionGuard
        requiredPermissions={[
          {
            action: 'Unit_Update',
            scope: 'Global',
          },
        ]}
      >
        <Link component={RouterLink} to={{ pathname: '/account/manage-units' }}>
          <TextV2 color="primary">
            {t(
              'ui.event-management.dashboard.quick-actions.credit-or-modify-units',
            )}
          </TextV2>
        </Link>
      </PermissionGuard>
      <PermissionGuard
        requiredPermissions={[
          {
            action: 'Organisation_Bulk_set_user_permissions',
            scope: 'Global',
          },
        ]}
      >
        <Link component={RouterLink} to="/organisations/set-bulk-permissions">
          <TextV2 color="primary">
            {t(
              'ui.event-management.dashboard.quick-actions.set-bulk-permissions',
            )}
          </TextV2>
        </Link>
      </PermissionGuard>
    </div>
  );
};

export default QuickActions;
